<template>
    <breadCrumbs title="Table Component" main="Bootstrap Table" title1="Table Component" />
    <div class="container-fluid">

        <div class="row">
            <rowComp />
            <checkComp />
            <radioComp />
            <selectrowComp />
            <inputComp />
            <badgeComp />
        </div>
    </div>
</template>
<script>
import checkComp from './checkComp.vue'
import radioComp from './radioComp.vue'
import selectrowComp from './selectrowComp.vue'
import inputComp from './inputComp.vue'
import badgeComp from './badgeComp.vue'
import rowComp from './rowComp.vue'
export default {
    components: {
        rowComp, checkComp, radioComp,
        selectrowComp, inputComp, badgeComp
    }
}
</script>